import * as React from 'react';

const ShareIosSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="share-ios_svg__eds-icon--share-ios_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="share-ios_svg__eds-icon--share-ios_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M21 17v4H3v-4H2v5h20v-5z"
        />
        <path
            id="share-ios_svg__eds-icon--share-ios_arrow"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M12 2l-.2.2L6 7.8l.7.7 4.7-4.6V18h1V3.9l4.8 4.7.8-.7L12 2z"
        />
    </svg>
);

ShareIosSvg.displayName = 'ShareIosSvg';
export default ShareIosSvg;
